<ngx-neo-appsdk-login>
    <div loginSidebar>
        <div class="row">
            <div class="img-holder">
                <div class="info-holder">
                    <h3>NEO Logs</h3>
                        <h4>{{appVersion}}</h4>
                        <img src="{{link}}/assets/images/tenant-logo.png" alt="HomePage-Logo"   onerror='this.onerror = null; this.src="assets/images/bcone-logo.png"'/>
                </div>
            </div>
        </div>
    </div>
    <div loginHeader i18n>
    Sign in to NEO Logs</div>
</ngx-neo-appsdk-login>